import { render, staticRenderFns } from "./RepositoryTabsView.vue?vue&type=template&id=9670f530&"
import script from "./RepositoryTabsView.vue?vue&type=script&lang=js&"
export * from "./RepositoryTabsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports